import { Link } from "wouter";
import { CREDITS } from "../../shared/credits.ts";

// Trilhar Desenvolvimento identity (BLD-21). Logos derived from the instructor's files: on-dark for the navy bars,
// on-light for white surfaces; the square mark is the lighthouse on navy.
export const LOGO_ON_DARK = "/brand/trilhar-logo-on-dark.png";
export const LOGO_ON_LIGHT = "/brand/trilhar-logo-on-light.png";
export const LOGO_ALT = "Trilhar Desenvolvimento";

export function BrandMark({ className = "size-8" }: { className?: string }) {
  return <img src="/brand/trilhar-mark.png" alt="" aria-hidden="true" className={`${className} rounded-[22%]`} />;
}

/** Logo + product name for the navy bars. `compact` keeps only the logo (inside a plan, next to the switcher). */
export function Brand({ href = "/planos", compact = false }: { href?: string; compact?: boolean }) {
  return (
    <Link href={href} className="tap inline-flex items-center gap-3 rounded-ctl text-white no-underline hover:opacity-90" aria-label="Planos de Gestão — minhas oficinas">
      <img src={LOGO_ON_DARK} alt={LOGO_ALT} className="h-10 w-auto sm:h-12" />
      {!compact && (
        <span className="hidden border-l border-white/25 pl-3 leading-tight sm:block">
          <span className="block text-[15px] font-bold tracking-tight">Planos de Gestão</span>
          <span className="block text-[11px] font-medium text-white/70">Oficinas de planejamento</span>
        </span>
      )}
    </Link>
  );
}

/** Credits line (instructor feedback, pt 9): auth pages, account pages and the plan area. */
export function Credits({ className = "" }: { className?: string }) {
  return (
    <footer className={`text-center text-xs text-muted ${className}`}>
      <p>
        Desenvolvido por <strong className="font-semibold text-ink/80">{CREDITS.developedBy}</strong>
        {" "}(<a href={`mailto:${CREDITS.contact}`} className="text-primary">{CREDITS.contact}</a>)
        <span aria-hidden> · </span>
        Concebido por <strong className="font-semibold text-ink/80">{CREDITS.conceivedBy}</strong>
      </p>
      <p className="mt-1 text-[11px] text-ink-3">{CREDITS.notice}</p>
    </footer>
  );
}
